/* El Prof Glow — storefront behaviour (vanilla, no dependencies) */
(function () {
  'use strict';
  var G = window.Glow || {};
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var isRTL = document.documentElement.dir === 'rtl';

  /* ---------- money ---------- */
  function money(cents) {
    var fmt = G.moneyFormat || '{{amount}}';
    var n = (cents / 100);
    function d(num, dec, ts, ds) {
      var p = num.toFixed(dec).split('.');
      p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return p.join(ds);
    }
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return d(n, 0, ',', '.');
      if (k === 'amount_with_comma_separator') return d(n, 2, '.', ',');
      if (k === 'amount_no_decimals_with_comma_separator') return d(n, 0, '.', ',');
      return d(n, 2, ',', '.');
    });
  }

  /* ---------- drawers ---------- */
  var scrim = $('[data-scrim]');
  var lastFocus = null;
  function openDrawer(id) {
    var d = document.getElementById(id);
    if (!d) return;
    closeAll(true);
    lastFocus = document.activeElement;
    d.classList.add('is-open');
    d.setAttribute('aria-hidden', 'false');
    scrim && scrim.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { var f = $('[data-close]', d) || d; f.focus(); }, 60);
    if (id === 'wish-drawer') renderWishDrawer();
  }
  function closeAll(silent) {
    $$('[data-drawer].is-open').forEach(function (d) { d.classList.remove('is-open'); d.setAttribute('aria-hidden', 'true'); });
    scrim && scrim.classList.remove('is-open');
    document.body.style.overflow = '';
    if (!silent && lastFocus && lastFocus.focus) lastFocus.focus();
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-open]');
    if (o) {
      var id = o.getAttribute('data-open');
      if (document.getElementById(id)) { e.preventDefault(); openDrawer(id); }
      return;
    }
    if (e.target.closest('[data-close]') || e.target.closest('[data-scrim]')) { closeAll(); }
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closeAll(); closeSearch(); }
  });

  /* mobile menu accordions */
  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-toggle]');
    if (!t) return;
    var sub = document.getElementById(t.getAttribute('aria-controls'));
    var open = t.getAttribute('aria-expanded') !== 'true';
    t.setAttribute('aria-expanded', open);
    if (sub) sub.hidden = !open;
  });

  /* ---------- header scroll state ---------- */
  var header = $('.header');
  if (header) {
    var onScroll = function () { header.classList.toggle('is-scrolled', window.scrollY > 8); };
    window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
  }

  /* ---------- cart ---------- */
  function setCount(n) {
    $$('[data-cart-count]').forEach(function (el) { el.textContent = n; if (n > 0) el.removeAttribute('data-zero'); else el.setAttribute('data-zero', ''); });
  }
  function bump(el) { if (!el) return; el.classList.remove('bump'); void el.offsetWidth; el.classList.add('bump'); }
  function visible(el) { if (!el) return false; var r = el.getBoundingClientRect(); return r.width > 0 && r.height > 0; }

  function refreshDrawer(open) {
    return fetch((G.routes.root || '/') + '?sections=cart-drawer', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var html = data['cart-drawer'];
        var cur = document.getElementById('cart-drawer');
        if (!html || !cur) return;
        var tmp = document.createElement('div'); tmp.innerHTML = html;
        var fresh = tmp.querySelector('#cart-drawer');
        if (fresh) cur.innerHTML = fresh.innerHTML;
        return fetch((G.routes.cart || '/cart') + '.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
      })
      .then(function (cart) { if (cart) setCount(cart.item_count); if (open) openDrawer('cart-drawer'); });
  }

  function flyFrom(src) {
    var target = $$('[data-cart-icon]').filter(visible)[0];
    if (!G.fly || reduce || !src || !target || !Element.prototype.animate) { bump(target); return; }
    var card = src.closest('[data-card]') || src.closest('[data-product]');
    var img = card && (card.querySelector('.card__img:not(.card__img--alt)') || card.querySelector('.gallery__slide img'));
    var s = (img && visible(img) ? img : src).getBoundingClientRect();
    var t = target.getBoundingClientRect();
    var f;
    if (img && (img.currentSrc || img.src)) { f = document.createElement('img'); f.src = img.currentSrc || img.src; f.alt = ''; }
    else f = document.createElement('span');
    f.className = 'fly'; f.setAttribute('aria-hidden', 'true'); document.body.appendChild(f);
    var x0 = s.left + s.width / 2 - 32, y0 = s.top + s.height / 2 - 32, x1 = t.left + t.width / 2 - 32, y1 = t.top + t.height / 2 - 32;
    f.animate([
      { transform: 'translate(' + x0 + 'px,' + y0 + 'px) scale(1)', opacity: 1 },
      { transform: 'translate(' + ((x0 + x1) / 2) + 'px,' + (Math.min(y0, y1) - 90) + 'px) scale(.8)', opacity: 1, offset: .5 },
      { transform: 'translate(' + x1 + 'px,' + y1 + 'px) scale(.2)', opacity: .4 }
    ], { duration: 700, easing: 'cubic-bezier(.5,0,.3,1)' }).onfinish = function () { f.remove(); bump(target); };
  }

  function addToCart(form, btn) {
    var fd = new FormData(form);
    btn && btn.classList.add('is-loading');
    return fetch((G.routes.cartAdd || '/cart/add') + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' }, credentials: 'same-origin' })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); })
      .then(function () { flyFrom(btn); return refreshDrawer(false); })
      .then(function () { setTimeout(function () { openDrawer('cart-drawer'); }, (G.fly && !reduce) ? 650 : 0); })
      .catch(function (err) { alertInline(form, (err && (err.description || err.message)) || 'Error'); })
      .then(function () { btn && btn.classList.remove('is-loading'); });
  }
  function alertInline(form, msg) {
    var n = form.querySelector('.notice--err');
    if (!n) { n = document.createElement('p'); n.className = 'notice notice--err'; n.setAttribute('role', 'alert'); form.appendChild(n); }
    n.textContent = msg;
    setTimeout(function () { n.remove(); }, 5000);
  }
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (f.matches('[data-add-form], #pform')) {
      e.preventDefault();
      addToCart(f, f.querySelector('[type="submit"]'));
    }
  });

  /* quantity change in drawer */
  var qtyTimer;
  function changeLine(line, qty) {
    var d = document.getElementById('cart-drawer');
    d && d.style.setProperty('opacity', '.6');
    return fetch((G.routes.cartChange || '/cart/change') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line: line, quantity: qty }), credentials: 'same-origin' })
      .then(function () { return refreshDrawer(false); })
      .then(function () { d && d.style.removeProperty('opacity'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('#cart-drawer [data-qty]');
    if (!b) return;
    changeLine(+b.getAttribute('data-qty'), Math.max(0, +b.getAttribute('data-to')));
  });
  document.addEventListener('change', function (e) {
    var i = e.target.closest('#cart-drawer [data-qty-input]');
    if (!i) return;
    clearTimeout(qtyTimer);
    qtyTimer = setTimeout(function () { changeLine(+i.getAttribute('data-qty-input'), Math.max(0, parseInt(i.value, 10) || 0)); }, 250);
  });

  /* ---------- wishlist (stored in this browser) ---------- */
  var WKEY = 'glow-wishlist';
  function wishGet() { try { return JSON.parse(localStorage.getItem(WKEY)) || []; } catch (e) { return []; } }
  function wishSet(a) { try { localStorage.setItem(WKEY, JSON.stringify(a)); } catch (e) {} }
  function syncHearts() {
    var list = wishGet();
    $$('[data-wish]').forEach(function (b) {
      var on = list.indexOf(b.getAttribute('data-wish')) > -1;
      b.setAttribute('aria-pressed', on);
      b.classList.toggle('is-on', on);
      if (b.hasAttribute('aria-label')) b.setAttribute('aria-label', on ? G.strings.wishRemove : G.strings.wishAdd);
      var lbl = b.querySelector('span'); if (b.hasAttribute('data-wish-btn') && lbl) lbl.textContent = on ? G.strings.wishRemove : G.strings.wishAdd;
    });
    $$('[data-wish-count]').forEach(function (c) { c.textContent = list.length || ''; if (list.length) c.removeAttribute('data-zero'); else c.setAttribute('data-zero', ''); });
  }
  function petals(el) {
    if (reduce) return;
    var cols = ['var(--c-berry)', 'var(--c-rose)', 'var(--c-champagne)'];
    for (var i = 0; i < 10; i++) {
      var p = document.createElement('span'); p.className = 'petal';
      var a = i / 10 * Math.PI * 2, r = 20 + Math.random() * 12;
      p.style.background = cols[i % 3]; p.style.setProperty('--x', Math.cos(a) * r + 'px'); p.style.setProperty('--y', Math.sin(a) * r + 'px');
      el.appendChild(p);
      (function (n) { setTimeout(function () { n.remove(); }, 800); })(p);
    }
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-wish]');
    if (!b) return;
    e.preventDefault();
    var h = b.getAttribute('data-wish'), list = wishGet(), i = list.indexOf(h);
    if (i > -1) list.splice(i, 1); else { list.unshift(h); petals(b); }
    wishSet(list.slice(0, 60));
    b.classList.remove('pop'); void b.offsetWidth; b.classList.add('pop');
    syncHearts();
    if (b.closest('#wish-drawer')) renderWishDrawer();
  });
  function esc(s) { return String(s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function renderWishDrawer() {
    var box = $('[data-wish-list]'), share = $('[data-wish-share]');
    if (!box) return;
    var list = wishGet();
    if (!list.length) { box.innerHTML = '<div class="c-empty">' + '<p>' + esc(G.strings.wishEmpty) + '</p></div>'; if (share) share.hidden = true; return; }
    if (share) share.hidden = false;
    Promise.all(list.map(function (h) {
      return fetch((G.routes.root || '/').replace(/\/$/, '') + '/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
    })).then(function (items) {
      items = items.filter(Boolean);
      box.innerHTML = items.map(function (p) {
        var img = p.featured_image ? p.featured_image.replace(/(\.[a-z]+)(\?|$)/i, '_200x$1$2') : '';
        return '<div class="c-item"><a class="c-item__img" href="' + esc(p.url) + '">' + (img ? '<img src="' + esc(img) + '" alt="" loading="lazy">' : '') + '</a>' +
          '<div class="c-item__info"><a class="c-item__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>' +
          '<div class="c-item__row"><span class="c-item__price">' + money(p.price) + '</span>' +
          '<button type="button" class="c-remove" data-wish="' + esc(p.handle) + '">' + esc(G.strings.wishRemove) + '</button></div></div></div>';
      }).join('');
      if (share) {
        var origin = location.origin;
        var txt = G.strings.wishIntro + '\n\n' + items.map(function (p) { return '• ' + p.title + ' (' + money(p.price) + ')\n' + origin + p.url; }).join('\n');
        share.href = 'https://wa.me/' + (G.whatsappShareTo || '') + '?text=' + encodeURIComponent(txt);
      }
    });
  }
  syncHearts();

  /* ---------- tabs ---------- */
  $$('[data-tabs]').forEach(function (root) {
    var tabs = $$('[role="tab"]', root);
    tabs.forEach(function (t, idx) {
      t.addEventListener('click', function () { select(idx); });
      t.addEventListener('keydown', function (e) {
        var dir = (e.key === 'ArrowRight' ? 1 : e.key === 'ArrowLeft' ? -1 : 0) * (isRTL ? -1 : 1);
        if (dir) { e.preventDefault(); var n = (idx + dir + tabs.length) % tabs.length; select(n); tabs[n].focus(); }
      });
    });
    function select(i) {
      tabs.forEach(function (t, j) {
        t.setAttribute('aria-selected', i === j);
        t.tabIndex = i === j ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = i !== j;
      });
    }
  });

  /* ---------- predictive search ---------- */
  var psForm = $('[data-ps]'), psInput = $('[data-ps-input]'), psBox = $('[data-ps-results]');
  var psDefault = psBox ? psBox.innerHTML : '';
  function closeSearch() { if (psInput && document.activeElement && psForm.contains(document.activeElement)) document.activeElement.blur(); }
  var psTimer, psCtrl;
  psInput && psInput.addEventListener('input', function () {
    var q = psInput.value.trim();
    clearTimeout(psTimer);
    if (q.length < 2) { psBox.innerHTML = psDefault; return; }
    psTimer = setTimeout(function () {
      if (psCtrl) psCtrl.abort();
      psCtrl = window.AbortController ? new AbortController() : null;
      fetch((G.routes.predictive || '/search/suggest') + '.json?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=8', psCtrl ? { signal: psCtrl.signal } : {})
        .then(function (r) { return r.json(); })
        .then(function (j) {
          var ps = (j.resources && j.resources.results && j.resources.results.products) || [];
          if (!ps.length) { psBox.innerHTML = '<p class="empty-state">' + esc(G.strings.noResults.replace('__T__', q)) + '</p>'; return; }
          psBox.innerHTML = '<div class="ps__list">' + ps.map(function (p) {
            return '<a class="ps__item" href="' + esc(p.url) + '">' + (p.image ? '<img src="' + esc(p.image) + '" alt="" loading="lazy">' : '<span></span>') +
              '<b>' + esc(p.title) + '</b><span class="price__now">' + money(Math.round(parseFloat(p.price) * 100)) + '</span></a>';
          }).join('') + '</div><p style="text-align:center;margin-top:16px"><a class="btn btn--ghost" href="' + (G.routes.search || '/search') + '?type=product&q=' + encodeURIComponent(q) + '">' + esc(G.strings.viewAll) + '</a></p>';
        }).catch(function () {});
    }, 220);
  });

  /* ---------- collection: sort & auto-submit filters ---------- */
  var sort = $('[data-sort]');
  sort && sort.addEventListener('change', function () {
    var u = new URL(location.href); u.searchParams.set('sort_by', sort.value); u.searchParams.delete('page'); location.href = u.toString();
  });
  $$('[data-facets]').forEach(function (f) {
    var t;
    f.addEventListener('change', function () {
      clearTimeout(t);
      t = setTimeout(function () {
        var params = new URLSearchParams(new FormData(f));
        Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
        location.href = f.getAttribute('action') + '?' + params.toString();
      }, 350);
    });
  });

  /* ---------- product page ---------- */
  var pRoot = $('[data-product]');
  if (pRoot) {
    var pjEl = $('[data-product-json]');
    var pj = pjEl ? JSON.parse(pjEl.textContent) : null;
    var form = $('#pform');
    var idInput = form && form.querySelector('[data-variant-id]');
    var atc = form && form.querySelector('[data-atc]');
    var atcLabel = atc && atc.querySelector('[data-atc-label]');
    var main = $('[data-gallery-main]');
    var thumbs = $$('[data-thumb]');
    var dots = $$('.gallery__dots i');

    function scrollToMedia(id) {
      var slide = document.getElementById('m-' + id);
      if (slide && main) main.scrollTo({ left: slide.offsetLeft - main.offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
    }
    thumbs.forEach(function (b) { b.addEventListener('click', function () { scrollToMedia(b.getAttribute('data-thumb')); }); });
    if (main) {
      var slides = $$('.gallery__slide', main);
      var io = new IntersectionObserver(function (ents) {
        ents.forEach(function (en) {
          if (!en.isIntersecting) return;
          var idx = slides.indexOf(en.target);
          thumbs.forEach(function (t, j) { t.setAttribute('aria-current', j === idx); });
          dots.forEach(function (d, j) { d.classList.toggle('on', j === idx); });
        });
      }, { root: main, threshold: .6 });
      slides.forEach(function (s) { io.observe(s); });
    }

    $$('[data-step]', form).forEach(function (b) {
      b.addEventListener('click', function () {
        var i = form.querySelector('input[name="quantity"]');
        i.value = Math.max(1, (parseInt(i.value, 10) || 1) + (+b.getAttribute('data-step')));
      });
    });

    function currentOptions() { return $$('.opt', form).map(function (fs) { var c = fs.querySelector('input:checked'); return c ? c.value : null; }); }
    function onVariantChange() {
      if (!pj) return;
      var opts = currentOptions();
      var v = pj.variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
      $$('.opt', form).forEach(function (fs, i) { var l = fs.querySelector('[data-opt-label]'); if (l) l.textContent = opts[i]; });
      if (!v) { atc.disabled = true; atcLabel.textContent = G.strings.unavailable; return; }
      idInput.value = v.id;
      atc.disabled = !v.available;
      atcLabel.textContent = v.available ? G.strings.add : G.strings.soldOut;
      var sale = v.compare_at_price && v.compare_at_price > v.price;
      var pw = $('[data-price-wrap] [data-price]');
      if (pw) {
        pw.classList.toggle('price--sale', !!sale);
        pw.innerHTML = '<span class="price__now">' + money(v.price) + '</span>' + (sale ? '<s class="price__was">' + money(v.compare_at_price) + '</s>' : '');
      }
      var bp = $('.buybox__price'); if (bp) bp.textContent = money(v.price);
      var po = $('.pinfo__off'); if (po) { po.hidden = !sale; if (sale) po.textContent = '-' + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + '%'; }
      var st = $('[data-stock]'); if (st) { st.classList.toggle('stock--out', !v.available); st.textContent = v.available ? (G.strings.inStock || st.textContent) : (G.strings.outOfStock || st.textContent); }
      var sp = $('[data-sticky-price]'); if (sp) sp.textContent = money(v.price);
      var sb = $('[data-sticky-btn]'); if (sb) sb.disabled = !v.available;
      if (v.featured_media) scrollToMedia(v.featured_media.id);
      var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString());
    }
    form && form.addEventListener('change', function (e) { if (e.target.closest('.opt')) onVariantChange(); });

    /* sticky add-to-cart bar on mobile */
    var sticky = $('[data-sticky-atc]');
    if (sticky && atc) {
      new IntersectionObserver(function (ents) {
        var off = !ents[0].isIntersecting && ents[0].boundingClientRect.top < 0;
        sticky.classList.toggle('is-on', off);
        sticky.setAttribute('aria-hidden', !off);
        var sb = $('[data-sticky-btn]', sticky); if (sb) sb.tabIndex = off ? 0 : -1;
      }).observe(atc);
      $('[data-sticky-btn]', sticky).addEventListener('click', function () { if (!atc.disabled) addToCart(form, this); });
    }
  }

  /* product recommendations */
  $$('[data-recos]').forEach(function (s) {
    var url = s.getAttribute('data-url');
    if (!url || s.children.length) return;
    fetch(url).then(function (r) { return r.text(); }).then(function (html) {
      var tmp = document.createElement('div'); tmp.innerHTML = html;
      var inner = tmp.querySelector('[data-recos]');
      if (inner && inner.innerHTML.trim()) { s.innerHTML = inner.innerHTML; syncHearts(); reveal(s); }
      else s.remove();
    }).catch(function () {});
  });

  /* ---------- banner slider & product rows ---------- */
  var isRtl = document.documentElement.dir === 'rtl';
  function scrollStep(track, dir, amount) {
    track.scrollBy({ left: (isRtl ? -dir : dir) * amount, behavior: reduce ? 'auto' : 'smooth' });
  }
  $$('[data-ahero]').forEach(function (hero) {
    var track = $('[data-ahero-track]', hero);
    var slides = track ? Array.prototype.slice.call(track.children) : [];
    if (slides.length < 2) return;
    var dots = $$('[data-ahero-dots] button', hero);
    function step() { var g = parseFloat(getComputedStyle(track).columnGap) || 0; return slides[0].offsetWidth + g; }
    function positions() { return Math.max(1, slides.length - Math.round((track.clientWidth + 1) / step()) + 1); }
    function idx() { return Math.round(Math.abs(track.scrollLeft) / step()); }
    function go(i) {
      var n = positions();
      i = (i + n) % n;
      track.scrollTo({ left: (isRtl ? -1 : 1) * i * step(), behavior: reduce ? 'auto' : 'smooth' });
    }
    function syncDots() { var i = idx(); dots.forEach(function (d, j) { d.setAttribute('aria-current', j === i); }); }
    track.addEventListener('scroll', function () { window.requestAnimationFrame(syncDots); }, { passive: true });
    dots.forEach(function (d, j) { d.addEventListener('click', function () { go(j); restart(); }); });
    var prev = $('[data-ahero-prev]', hero), next = $('[data-ahero-next]', hero);
    prev && prev.addEventListener('click', function () { go(idx() - 1); restart(); });
    next && next.addEventListener('click', function () { go(idx() + 1); restart(); });
    var ms = (parseInt(hero.getAttribute('data-speed'), 10) || 5) * 1000, timer;
    function restart() { clearInterval(timer); if (!reduce) timer = setInterval(function () { if (!document.hidden) go(idx() + 1); }, ms); }
    hero.addEventListener('mouseenter', function () { clearInterval(timer); });
    hero.addEventListener('mouseleave', restart);
    hero.addEventListener('focusin', function () { clearInterval(timer); });
    hero.addEventListener('touchstart', function () { clearInterval(timer); }, { passive: true });
    hero.addEventListener('touchend', restart, { passive: true });
    restart();
  });
  $$('[data-arow]').forEach(function (row) {
    var track = $('[data-arow-track]', row);
    var prev = $('[data-arow-prev]', row), next = $('[data-arow-next]', row);
    if (!track) return;
    function sync() {
      var max = track.scrollWidth - track.clientWidth - 2, x = Math.abs(track.scrollLeft);
      if (prev) prev.hidden = x <= 2;
      if (next) next.hidden = x >= max;
    }
    prev && prev.addEventListener('click', function () { scrollStep(track, -1, track.clientWidth * .85); });
    next && next.addEventListener('click', function () { scrollStep(track, 1, track.clientWidth * .85); });
    track.addEventListener('scroll', sync, { passive: true });
    window.addEventListener('resize', sync);
    sync();
  });

  /* ---------- reveal on scroll ---------- */
  function reveal(scope) {
    if (!G.reveal || reduce || !('IntersectionObserver' in window)) return;
    var els = $$('.reveal:not(.is-seen)', scope);
    var vh = window.innerHeight;
    var io = new IntersectionObserver(function (ents) {
      ents.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.remove('is-pending'); en.target.classList.add('is-seen'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el, i) {
      if (el.getBoundingClientRect().top < vh) { el.classList.add('is-seen'); return; }
      el.classList.add('is-pending');
      el.style.transitionDelay = (i % 4) * 70 + 'ms';
      io.observe(el);
    });
  }
  reveal(document);
})();
